export const profilePermissionGroups = [
  {
    label: "Dashboard",
    root: { key: "page:dashboard", label: "Acesso total" },
    permissions: [{ key: "dashboard:list", label: "Listar" }],
  },
  {
    label: "Atendimentos",
    root: { key: "page:tickets", label: "Acesso total" },
    permissions: [
      { key: "tickets:list", label: "Listar" },
      { key: "tickets:create", label: "Criar" },
      { key: "tickets:send", label: "Enviar mensagem" },
      { key: "tickets:edit", label: "Editar" },
      { key: "tickets:delete", label: "Excluir" },
      { key: "tickets:mark-unread", label: "Marcar como não lido" },
      { key: "tickets:history", label: "Importar histórico" },
      { key: "tickets:transfer-whatsapp", label: "Transferir conexão" },
      { key: "tickets:show-all", label: "Ver todos" },
    ],
  },
  {
    label: "Auditoria de contatos",
    root: { key: "page:ticket-audits", label: "Acesso total" },
    permissions: [
      { key: "ticket-audits:list", label: "Listar" },
      { key: "ticket-audits:edit", label: "Editar" },
    ],
  },
  {
    label: "Comunicação Interna",
    root: { key: "page:internal-chat", label: "Acesso total" },
    permissions: [
      { key: "internal-chat:list", label: "Listar" },
      { key: "internal-chat:create", label: "Criar" },
      { key: "internal-chat:delete", label: "Excluir" },
    ],
  },
  {
    label: "Contatos",
    root: { key: "page:contacts", label: "Acesso total" },
    permissions: [
      { key: "contacts:list", label: "Listar" },
      { key: "contacts:create", label: "Criar" },
      { key: "contacts:edit", label: "Editar" },
      { key: "contacts:delete", label: "Excluir" },
      { key: "contacts:import", label: "Importar" },
    ],
  },
  {
    label: "Respostas Rápidas",
    root: { key: "page:quickAnswers", label: "Acesso total" },
    permissions: [
      { key: "quickAnswers:list", label: "Listar" },
      { key: "quickAnswers:create", label: "Criar" },
      { key: "quickAnswers:edit", label: "Editar" },
      { key: "quickAnswers:delete", label: "Excluir" },
    ],
  },
  {
    label: "Agendamento em Massa",
    root: { key: "page:scheduled-broadcasts", label: "Acesso total" },
    permissions: [
      { key: "scheduled-broadcasts:list", label: "Listar" },
      { key: "scheduled-broadcasts:create", label: "Criar" },
      { key: "scheduled-broadcasts:cancel", label: "Cancelar" },
      { key: "scheduled-broadcasts:delete", label: "Excluir" },
    ],
  },
  {
    label: "Instâncias",
    root: { key: "page:connections", label: "Acesso total" },
    permissions: [
      { key: "connections:list", label: "Listar" },
      { key: "connections:create", label: "Criar" },
      { key: "connections:edit", label: "Editar" },
      { key: "connections:delete", label: "Excluir" },
      { key: "connections:start-session", label: "Iniciar sessão" },
      { key: "connections:restart-session", label: "Reiniciar sessão" },
      { key: "connections:disconnect-session", label: "Desconectar sessão" },
    ],
  },
  {
    label: "Usuários",
    root: { key: "page:users", label: "Acesso total" },
    permissions: [
      { key: "users:list", label: "Listar" },
      { key: "users:create", label: "Criar" },
      { key: "users:edit", label: "Editar" },
      { key: "users:delete", label: "Excluir" },
    ],
  },
  {
    label: "Perfis",
    root: { key: "page:profiles", label: "Acesso total" },
    permissions: [
      { key: "profiles:list", label: "Listar" },
      { key: "profiles:create", label: "Criar" },
      { key: "profiles:edit", label: "Editar" },
      { key: "profiles:delete", label: "Excluir" },
    ],
  },
  {
    label: "Etiquetas",
    root: { key: "page:tags", label: "Acesso total" },
    permissions: [
      { key: "tags:list", label: "Listar" },
      { key: "tags:create", label: "Criar" },
      { key: "tags:edit", label: "Editar" },
      { key: "tags:delete", label: "Excluir" },
    ],
  },
  {
    label: "Departamentos",
    root: { key: "page:queues", label: "Acesso total" },
    permissions: [
      { key: "queues:list", label: "Listar" },
      { key: "queues:create", label: "Criar" },
      { key: "queues:edit", label: "Editar" },
      { key: "queues:delete", label: "Excluir" },
    ],
  },
  {
    label: "Configurações",
    root: { key: "page:settings", label: "Acesso total" },
    permissions: [
      { key: "settings:list", label: "Listar" },
      { key: "settings:edit", label: "Editar" },
    ],
  },
  {
    label: "Legado",
    permissions: [
      { key: "drawer-admin-items:view", label: "Menu administrativo - Visualizar" },
      { key: "tickets-manager:showall", label: "Atendimentos - Ver todos" },
      { key: "user-modal:editProfile", label: "Usuários - Alterar perfil" },
      { key: "user-modal:editQueues", label: "Usuários - Alterar filas e conexão" },
      { key: "ticket-options:deleteTicket", label: "Atendimentos - Excluir" },
      { key: "ticket-options:transferWhatsapp", label: "Atendimentos - Transferir conexão" },
      { key: "contacts-page:deleteContact", label: "Contatos - Excluir" },
    ],
  },
];

const profilePermissions = profilePermissionGroups.flatMap(group =>
  [group.root, ...group.permissions].filter(Boolean)
);

export const getAdminPermissions = () => profilePermissions.map(item => item.key);

export default profilePermissions;
